// @flow
import type { TridentCampaignDetails } from 'types/trident-campaigns';
import React, { Component } from 'react';
import i18n from 'i18n-js';
import _ from 'lodash';
import FormInputWithError from 'components/form/FormInputWithError';
import { Form, Grid } from 'semantic-grab-ui/src';
import formComponent from 'components/decorators/form_component';

type Props = {
  model: TridentCampaignDetails,
  canActivate: boolean,
  currentNode: string,
  subActionIndex: number,
  onModelChange: (_?: Object) => void,
  handleInputChange: Function,
  handleControlBlur: Function,
};

@formComponent()
export default class ActionSendSlackForm extends Component {
  props: Props;

  render() {
    const { model, currentNode, subActionIndex } = this.props;
    return (
      <Form>
        <Grid>
          <Grid.Row>
            <Grid.Column width={12}>
              <FormInputWithError
                name={`nodes.${currentNode}.data[${subActionIndex}].meta.slackPayload.data`}
                {...this.props}
              >
                <Form.TextArea
                  required
                  label={i18n.t('targets_page.fields.channels')}
                  value={_.get(model.nodes[currentNode], `data[${subActionIndex}].meta.slackPayload.data`)}
                  onChange={this.props.handleInputChange}
                  onBlur={this.props.handleControlBlur}
                />
              </FormInputWithError>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={12}>
              <FormInputWithError
                name={`nodes.${currentNode}.data[${subActionIndex}].meta.slackPayload.template`}
                {...this.props}
              >
                <Form.TextArea
                  required
                  label={i18n.t('targets_page.fields.template')}
                  value={_.get(model.nodes[currentNode], `data[${subActionIndex}].meta.slackPayload.template`)}
                  onChange={this.props.handleInputChange}
                  onBlur={this.props.handleControlBlur}
                />
              </FormInputWithError>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}
